import React, { useState, useRef, useEffect } from "react";
import MRMSLogo from "../../../src/assets/Images/LoginImages/MRMSLogo.png";
import PoweredBy from '../../../src/assets/Images/LoginImages/PoweredBy.png';
import { useNavigate, useSearchParams } from "react-router-dom";
import { addLoginResponse } from "../../features/login/loginSlice";
import { useDispatch } from "react-redux";
import APICom from "../../utils/helpers/APICom";
import ModuleSecurity from "../../utils/helpers/ModuleSecurity";
import PersistStorage from '../../utils/helpers/PersistStorage';
import CommonFunctions from "../../utils/helpers/CommonFunctions";
import DateTimeUtils from "../../utils/DateTimeUtility.js";
import moment from "moment";


const Login = () => {
  
    PersistStorage.save("DispatchToolBarDate", null, 360, false);
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    const [Message, setMessage] = useState("");
    let _username = searchParams.get("u");
    let _password = searchParams.get("p");
    let _ext = searchParams.get("ext");
    let _station = searchParams.get("station");
    let _vMethod = searchParams.get("method");
    let _applicationsessionid = searchParams.get("applicationsessionid");
    let _useriplist = searchParams.get("useriplist");
    try {
        if(_username == null) { _username = ""; }
        if(_password == null) { _password = ""; }
    }
    catch (err) { }
    //Form values
    const [login, setLogin] =
        useState({
            vUserName: _username, vPassword: _password, vExtension: '', errorMsg: '', vStation: '', vMethod: '',
            vApplicationSessionID: '', vUserIPList: '', isLogin: false
        });
    const navigate = useNavigate();
    const signInButton = useRef(null);
    
    const InitiateLoginAuto = async () => {
        setLogin({ ...login, errorMsg: "", isLogin: false }); 
        {
            const userIPResponse = await APICom.fetchData("full", 'https://api.ipify.org?format=json', "get", {}, {});
            let userIP = "";
            if(userIPResponse && userIPResponse.error === '')
            {
                if(userIPResponse.data.ip && userIPResponse.data.ip.length > 0)
                {
                    userIP = userIPResponse.data.ip;
                }
                else
                {
                    userIP = "50.204.237.2";
                }
            }
            else
            {
                userIP = "50.204.237.2";
            }
            const data = {
                "vUserName": login.vUserName,
                "vPassword": login.vPassword,
                "vStation": String(userIP)+"/"+String(userIP),
                "vMethod": "MRMS-MRMSDispatchAutoLogin",
                "vApplicationSessionID": "WebMRMS-chrome_114-Windows@Time_21/7/2023 @ 16:42:55",
                "vExtension": login.vExtension === ""? 1:login.vExtension,
                "vUserIPList": String(userIP)
            }
            try
            {
                const response = await APICom.fetchData("main", "AuthActions/GetUserValidation", "post", {}, data);
                if (response.error !== "") {
                    setMessage(response.error);
                    setLogin({ ...login, errorMsg : response.error});  
                }
                else if(response.data[0].hasOwnProperty("MSG"))
                {
                    setMessage(response.data[0].MSG);
                    setLogin({ ...login, errorMsg : response.data[0].MSG});  
                }
                else
                {
                    if(response.data[0].IsPowerUser === true){
                        await ModuleSecurity.PowerUserModules(response.data[0].iUserID, response.data[0].recordID);
                    }
                    else {
                        await ModuleSecurity.FetchAndSaveUserAssignedModules(response.data[0].iUserID, response.data[0].recordID);
                    }
                    try
                    {
                    let serverDateTime = await DateTimeUtils.getCurrentSystemDateTime();
                    let ServDateTime = moment(serverDateTime, 'MM/DD/YYYY hh:mmA');
                    let currentSystemTime = moment();
                    let timeZoneDiff = ServDateTime.diff(currentSystemTime);
                    response.data[0].TimeZoneDifference = timeZoneDiff;
                    }
                    catch(timeZoneDiffExp)
                    {
                        console.log(`Time Zone Difference : ${timeZoneDiffExp}`);
                    }     
                    setLogin({ ...login, errorMsg:'', isLogin: true });
                    // added vExtension to login data
                    response.data[0].vExtension = login.vExtension
                    dispatch(addLoginResponse(response.data[0]));
                    await CommonFunctions.PopulateGridColorData(response.data[0].iUserID, dispatch)
                    //setForLoginInLocalStorage(response);
                    navigate('/Dispatch');
                }    
            }catch(e)
            {
                console.log(e);
            }
            
        }
    }
    useEffect(() => {
        try{
            const clearCacheData = () => {
                try{
                    if ('caches' in window) {
                        caches.keys().then(cacheNames => {
                            cacheNames.forEach(cacheName => {
                                caches.delete(cacheName); // Deletes each cache
                            });
                        });
                    }
                    // console.log("Complete Cache Cleared");
                }
                catch(err) {console.log(err);}
            };        
            const clearCookies = () => {
                try{
                    const cookies = document.cookie.split(";");
            
                    cookies.forEach((cookie) => {
                        const eqPos = cookie.indexOf("=");
                        const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
                        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
                    });
                }
                catch(err){console.log(err);}
            };
            function clearLocalStorageExcept(exceptKey) {
                try{
                    // Store the value of the key you want to retain
                    const retainedValue = localStorage.getItem(exceptKey);
                    // Also retain the auto-updater version key!
                    const retainedVersion = localStorage.getItem("app_version_webmrms2");
                
                    // Clear all localStorage data
                    localStorage.clear();
                
                    // Restore the retained key-value pair
                    if (retainedValue !== null) {
                        localStorage.setItem(exceptKey, retainedValue);
                    }
                    if (retainedVersion !== null) {
                        localStorage.setItem("app_version_webmrms2", retainedVersion);
                    }
                }
                catch(err){console.log(err);}
            };
            clearLocalStorageExcept("persist:configurationSlice"); // Clears all data from localStorage (except Important Cached Data)
            sessionStorage.clear(); // Clears all data from sessionStorage
            clearCacheData();
            clearCookies();
            if(login.vUserName != null && login.vUserName != "") {
                InitiateLoginAuto();
            }
        }
        catch(oil) { }
        return () => {
            
        }
    }, []);

    //Events to Set useState value
    const handleInputChange = (e) => {
        const regexx = /^[0-9\b]+$/;
        if (e.target.name === "vExtension") {
            if (e.target.value === '' || regexx.test(e.target.value)) {
                setLogin({ ...login, [e.target.name]: e.target.value });
            }
        }
        else {
            setLogin({ ...login, [e.target.name]: e.target.value });
        }
    }

    const handleKeyPress = (e) => {
        if (e.key === "Enter" || e.key === "enter") {
            e.preventDefault();
            signInButton.current.click();
        }
    }

    const handleExtensionInput = (e) => {
        e.target.value = e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');
    }

    const InitiateLogin = async (e) => {
        e.preventDefault();
        const userIPResponse = await APICom.fetchData("full", 'https://api.ipify.org?format=json', "get", {}, {});
        let userIP = "";
        if(userIPResponse && userIPResponse.error === '')
        {
            if(userIPResponse.data.ip && userIPResponse.data.ip.length > 0)
            {
                userIP = userIPResponse.data.ip;
            }
            else
            {
                userIP = "50.204.237.2";
            }
        }
        else
        {
            userIP = "50.204.237.2";
        }
        
        setLogin({ ...login, errorMsg: "", isLogin: false }); 
        if(!login.vUserName)
        {
            setLogin({ ...login, errorMsg : 'Please provide username'});  
        }
        else if(!login.vPassword)
        {
            setLogin({ ...login, errorMsg : 'Please provide password'});  
        }
        else
        {
            const data = {
                "vUserName": login.vUserName,
                "vPassword": login.vPassword,
                "vStation": String(userIP)+"/"+String(userIP),
                "vMethod": "MRMS-MRMSDispatchLogin",
                "vApplicationSessionID": "WebMRMS-chrome_114-Windows@Time_21/7/2023 @ 16:42:55",
                "vExtension": login.vExtension === ""? 1:login.vExtension,
                "vUserIPList": String(userIP)
            }
            try
            {
                const response = await APICom.fetchData("main", "AuthActions/GetUserValidation", "post", {}, data);
                if (response.error !== "") {
                    setLogin({ ...login, errorMsg: response.error, isLogin: false }); 
                }
                else if(response.data[0].hasOwnProperty("MSG"))
                {
                    setLogin({ ...login, errorMsg: response.data[0].MSG, isLogin: false }); 
                }
                else
                {
                    if(response.data[0].IsPowerUser === true){
                        await ModuleSecurity.PowerUserModules(response.data[0].iUserID, response.data[0].recordID);
                    }
                    else {
                        await ModuleSecurity.FetchAndSaveUserAssignedModules(response.data[0].iUserID, response.data[0].recordID);
                    }
                    setLogin({ ...login, errorMsg:'', isLogin: true });
                    // added extension to logindata
                    response.data[0].vExtension = login.vExtension
                    response.data[0].BuildManifestDispatchID=false;
                     try
                    {
                        let serverDateTime = await DateTimeUtils.getCurrentSystemDateTime();
                        let ServDateTime = moment(serverDateTime, 'MM/DD/YYYY hh:mmA');
                        let currentSystemTime = moment();
                        let timeZoneDiff = ServDateTime.diff(currentSystemTime);
                        response.data[0].TimeZoneDifference = timeZoneDiff;
                    }
                    catch(timeZoneDiffExp)
                    {
                        console.log(`Time Zone Difference : ${timeZoneDiffExp}`);
                    } 
                    dispatch(addLoginResponse(response.data[0]));
                    await CommonFunctions.PopulateGridColorData(response.data[0].iUserAffiliateID, dispatch)
                    //setForLoginInLocalStorage(response);
                    navigate('/Dispatch');

                }    
            }catch(e)
            {
                console.log(e);
            }
            
        }
    }

    const setForLoginInLocalStorage = (response) => {
        try {
            localStorage.setItem(
                "forceLogin",
                JSON.stringify({
                  user: response.data[0],
                  redirectTo: '/Dispatch',
                  ts: Date.now()
                })
              );

        } catch (error) {
            
        }
    }

    if (!login.isLogin)
    {

        return(
            <div>
                <div className="row text-center d-block LoginHeight mx-auto" id="loginHead">
                    <div className="col bg-white rounded align-middle mx-auto shadow-sm" id="loginDiv">
                        <div className="row headerLogoFrame">
                            <div className="col h-100 p-0">
                                <img id = "MRMSlogoLogin" className="w-100 h-100 rounded-top" src={MRMSLogo} alt="IT Curves"/>
                            </div>
                        </div>
                        <div className="row mt-2 loginBodyContainer">
                            <div className="col mx-auto" id="loginBody">
                                <h5 className="fw-bold prevent-select">User Login</h5>
                                <input type="text" placeholder="Username" name="vUserName" value={login.vUserName} onKeyUp={handleKeyPress}  onChange={handleInputChange} onFocus={() => setLogin({ ...login, errorMsg: '' })} autoComplete="off" id="userName" className="text-start fw-normal form-control mt-3 loginInputFields" required/>
                                <input type="password" placeholder="Password" name="vPassword" value={login.vPassword} onKeyUp={handleKeyPress} onChange={handleInputChange} onFocus={() => setLogin({ ...login, errorMsg: '' })} autoComplete="off" id="userPass" className="text-start fw-normal form-control mt-3 loginInputFields" required/>
                                <input type="text" placeholder="Extension" name="vExtension" value={login.vExtension} onInput={handleExtensionInput} onKeyUp={handleKeyPress} onChange={handleInputChange} autoComplete="off" id="userExt" className="text-start fw-normal form-control mt-3 loginInputFields" maxLength="4"/>
                                <div className="forgotpassloginContainer"><a className="float-end fw-normal text-decoration-none" href="#ForgotPass">Forgot Password</a></div>
                                <button type="button" onClick={InitiateLogin} ref={ signInButton } id="userLoginBtn" className="btn fw-bold customSignInBtn border-dark">Sign In</button>
                                <div className="rounded w-100 mx-auto errorContainerLogin">
                                    <label className="login_error_message text-wrap" name="errormessage" >{login.errorMsg}</label>
                                </div>
                                <img className = "mx-auto login_poweredby_Image_Width" title="Login Page" src={PoweredBy} alt="Powered By IT Curves"/>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        )
    }

};


export default Login;